export default __webpack_public_path__ + "static/media/Metalic.2a4fc993.mp3";